import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Considerapp = () => {
  return (
    <div className="consider_usa p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={5} xxl={5}>
            <div className="consider_content">
              <h2>
                When to Consider our Custom Healthcare Software Development
                Services
              </h2>
              <p>
                Whether you're starting a new healthcare software project or
                want to upgrade, we promise flawless, bespoke solutions that are
                suited to your specific requirements.
              </p>
              <p>
                Here's when you might consider using our software development
                services for healthcare.
              </p>
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                Let’s Build Your Project Now!
              </Link>
            </div>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="offset-xl-1">
            <div className="consider-box">
              <h6>Launching a New App</h6>
              <p>
                If you're introducing something new, like your own app. Our
                healthcare development services excel in infusing your vision
                with specific features, ensuring a successful launch
              </p>
            </div>
            <div className="consider-box">
              <h6>Modernization</h6>
              <p>
                Upgrade your outdated software with our custom healthcare
                development services. We can introduce new features to ensure
                optimal performance and customer satisfaction.
              </p>
            </div>
            <div className="consider-box">
              <h6>Compliance</h6>
              <p>
                We provide innovative and HIPAA-compliant software development
                services. Our fully compliant approach ensures adherence to all
                regulatory standards & data security protocols, protecting
                patient information.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Considerapp;
